module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/SEVEN@1x.png?1.0.17";